/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DismissPlatformMCPOnboardingSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DismissPlatformMCPOnboardingRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DismissPlatformMCPOnboardingSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DismissPlatformMCPOnboardingSecurity$outboundSchema: z.ZodMiniType<
  DismissPlatformMCPOnboardingSecurity$Outbound,
  DismissPlatformMCPOnboardingSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function dismissPlatformMCPOnboardingSecurityToJSON(
  dismissPlatformMCPOnboardingSecurity: DismissPlatformMCPOnboardingSecurity,
): string {
  return JSON.stringify(
    DismissPlatformMCPOnboardingSecurity$outboundSchema.parse(
      dismissPlatformMCPOnboardingSecurity,
    ),
  );
}

/** @internal */
export type DismissPlatformMCPOnboardingRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DismissPlatformMCPOnboardingRequest$outboundSchema: z.ZodMiniType<
  DismissPlatformMCPOnboardingRequest$Outbound,
  DismissPlatformMCPOnboardingRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function dismissPlatformMCPOnboardingRequestToJSON(
  dismissPlatformMCPOnboardingRequest: DismissPlatformMCPOnboardingRequest,
): string {
  return JSON.stringify(
    DismissPlatformMCPOnboardingRequest$outboundSchema.parse(
      dismissPlatformMCPOnboardingRequest,
    ),
  );
}
